const state = {
  theme: false,  //false 正常白色 //true 深色模式
}

const mutations = {
  UPDATE_THEME(state, data) {
    state.theme = data
  },
}

const actions = {
  updateTheme({ commit }, data) {
    commit('UPDATE_THEME', data)
  },
}

const getters = {
  getTheme: state => state.theme,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}